export var BackupZeroEtlIdentityColumnField;
(function (BackupZeroEtlIdentityColumnField) {
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_CLOUD_PROVIDER"] = "CLOUD_PROVIDER";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_CLOUD_ACCOUNT_ID"] = "CLOUD_ACCOUNT_ID";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_REGION"] = "REGION";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_RESOURCE_ID"] = "RESOURCE_ID";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_DATABASE"] = "DATABASE";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_SCHEMA"] = "SCHEMA";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_TABLE"] = "TABLE";
})(BackupZeroEtlIdentityColumnField || (BackupZeroEtlIdentityColumnField = {}));
